import React, { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Image from 'next/image';

export default function RedirectToFaithFi() {
  const router = useRouter();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      router.push('https://www.faithfi.com/find?utm_source=kingdomadvisors&utm_medium=website&utm_campaign=webredirect');
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, [router]);

  return (
    <>
      <Head>
        <title>Redirecting...</title>
      </Head>
      <div className="flex items-center justify-center h-screen" >
        <div className="text-center p-6 bg-white shadow-md rounded-lg" style={{maxWidth: 650}}>
          <Image
            src="/static/images/logo.png"
            alt="Kingdom Advisor Logo"
            width={300}
            height={50}
            className='h-auto'
          />
          <h1 className="text-xl font-semibold mb-4">
            Redirecting...
          </h1>
          <p className="mb-5">
            You are now being redirected to FaithFi® to complete your CKA® search. FaithFi® is a wholly-owned and operated ministry
            of Kingdom Advisors serving individuals and families.
          </p>
        </div>
      </div>
    </>
  );
}

RedirectToFaithFi.getLayout = page => <>{page}</>;
RedirectToFaithFi.isPublic = true;
